import { render, staticRenderFns } from "./AddonColumn.vue?vue&type=template&id=de1955c6&scoped=true&"
import script from "./AddonColumn.vue?vue&type=script&lang=js&"
export * from "./AddonColumn.vue?vue&type=script&lang=js&"
import style0 from "./AddonColumn.vue?vue&type=style&index=0&id=de1955c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1955c6",
  null
  
)

export default component.exports